module.exports = __webpack_public_path__ + "img/logo.25eea750.png";